export enum FinancialModelType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}
